import { render, staticRenderFns } from "./FormularioAddAnemia.vue?vue&type=template&id=ac9c465c&scoped=true"
import script from "./FormularioAddAnemia.vue?vue&type=script&lang=js"
export * from "./FormularioAddAnemia.vue?vue&type=script&lang=js"
import style0 from "./FormularioAddAnemia.vue?vue&type=style&index=0&id=ac9c465c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9c465c",
  null
  
)

export default component.exports